import { consoleRoutes } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { AppLink, Badge, Button, Icon } from "@sagot/ui";
import { useWorkspaceContext } from "../session/workspace-context";

/** Upgrade empty-state for Starter / Standard (custom roles are Pro / Institution, Amendment B). */
export function PlanGateCard({ plan }: { plan: string | undefined }) {
  const { t } = useTranslation();
  const { summary } = useWorkspaceContext();
  const planName = plan ? t(`console.plans.${plan}`, { defaultValue: plan }) : "";
  return (
    <section className="card card-body flex flex-col gap-4 md:flex-row md:items-center" aria-labelledby="plan-gate-title" data-testid="plan-gate">
      <span className="inline-flex size-12 shrink-0 items-center justify-center rounded-lg bg-primary-soft text-primary-ink">
        <Icon name="shield-check" className="size-6" />
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <h2 id="plan-gate-title" className="text-base font-bold">
            {t("roles.planGate.title")}
          </h2>
          <Badge tone="neutral">
            <Icon name="lock" className="size-3" />
            {t("roles.planGate.badge")}
          </Badge>
        </div>
        <p className="mt-1 text-sm text-fg-muted">{t("roles.planGate.body", { plan: planName })}</p>
        <p className="mt-1 text-xs text-fg-subtle">{t("roles.planGate.builtInsBelow")}</p>
      </div>
      <Button asChild>
        <AppLink href={consoleRoutes.billing(summary.slug)}>
          <Icon name="arrow-up-right" />
          {t("roles.planGate.upgrade")}
        </AppLink>
      </Button>
    </section>
  );
}
